export default "__VITE_ASSET__DjDz4xeL__"